import store from '@/store'

const pattern = {
  name: /^([A-Za-z]|[\u0391-\uFFE5]){1,30}$/,
  phone: /^1[3-9]\d{9}$/,
  number: /^\d+$/,
  startNumber: /^\d+$/,
  endNumber: /^\d+$/,
  isPhone: /^\d{3,4}-?\d{7,9}$/,  // 传真手机
  isZipCode: /^[0-9]{6}$/,        // 邮编
  isLoginName: /^[0-9A-Za-z]+$/,
  isPassword: /^[(0-9A-Za-z)@]+$/,
  isName: /^([A-Za-z]|[\u0391-\uFFE5])+$/,
  isEmail: /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/,
  isMobile: /^1[3-9]\d{9}$/,
  isPMobile: /^((\d{3,4}-?\d{4,9})|(1[3-9]\d{9}))$/ // 手机和固定电话
}

export const password = {
  reg: pattern.isPassword,
  errorMsg: '密码长度为6~16位,可包含数字，字母，@符号'
};

const loginNameValidate = (rule, value, callback) => {
  if (!value) {
    callback(new Error('请输入用户名'));
  } else if (!pattern.isLoginName.test(value)) {
    callback(new Error('用户名可用数字和字母'));
  } else {
    callback();
  }
};

const nameValidate = (rule, value, callback) => {
  if (!value) {
    callback();
  } else if (!pattern.name.test(value)) {
    callback(new Error('禁用特殊字符和数字'));
  } else {
    callback();
  }
};

const mobileValidate = (rule, value, callback) => {
  if (!value) {
    if (store.getters.needMobile === '1') {
      callback(new Error('请输入手机号码'));
    } else {
      callback();
    }
  } else if (!pattern.isMobile.test(value)) {
    callback(new Error('请您输入正确的手机号码，以便密码找回'));
  } else {
    callback();
  }
};

const pmobileValidate = (rule, value, callback) => {
  if (!value) {
    callback();
  } else if (!pattern.isPMobile.test(value)) {
    callback(new Error('请正确输入号码'));
  } else {
    callback();
  }
};

const emailValidate = (rule, value, callback) => {
  if (!value) {
    callback();
  } else if (!pattern.isEmail.test(value)) {
    callback(new Error('请正确输入邮箱'));
  } else {
    callback();
  }
};

const zipCodeValidate = (rule, value, callback) => {
  if (!pattern.isZipCode.test(value)) {
    callback(new Error('请正确输入邮政编码'));
  } else {
    callback();
  }
};

const passwordValidate = (rule, value, callback) => {
  if (!pattern.isPassword.test(value)) {
    callback(new Error('密码由数字，字母或 @ 组成'));
  } else {
    callback();
  }
};

const checkPassValidate = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请再次输入密码'));
  } else {
    callback();
  }
};

// 角色验证规则
export const orgId = [
  { required: true, message: '请选择上级机构', trigger: 'blur' },
]

export const name = [
  { required: true, message: '请输入角色名称', trigger: 'blur, change' },
  { min: 0, max: 30, message: '长度不大于30个字符', trigger: 'blur, change' }
]

export const remarks =  [
  { required: true, message: '请输入角色描述', trigger: 'blur, change' },
  { min: 0, max: 150, message: '长度不大于150个字符', trigger: 'blur, change' }
]

// 用户验证规则
export const loginName = [
  { validator: loginNameValidate, trigger: 'blur, change' },
]

export const userName = [
  { required: true, message: '请输入姓名', trigger: 'blur, change' },
]

// 手机验证规则
export const mobile = [
  { validator: mobileValidate, trigger: 'blur, change' },
]

// 固定电话验证规则
export const phone = [
  { validator: pmobileValidate, trigger: 'blur, change' },
]

export const email = [
  { required: true, message: '请输入邮箱', trigger: 'blur, change' },
  { validator: emailValidate, trigger: 'blur, change' },
]

export const changPassword = [
  { required: true, message: '请输入密码', trigger: 'blur, change' },
  { min: 8, max: 20, message: '密码长度8~20个字符', trigger: 'blur, change' },
  { validator: passwordValidate, trigger: 'blur, change' },
]

export const checkPass = [
  { validator: checkPassValidate, trigger: 'blur, change' },
]

// 角色管理验证
export const roles ={
  orgId,
  name,
  remarks
};

// 用户管理验证
export const users = {
  loginName,
  name: userName,
  mobile,
  phone,
  email,
};

// 个人信息补全验证
export const changeEmail = {
  email,
  password: changPassword,
  checkPass: checkPass
}

// 基本信息修改
export const baseUser = {
  email: [
    { required: true, message: '请输入邮箱', trigger: 'blur, change' },
    { validator: emailValidate, trigger: 'blur, change' },
  ],
  phone,
  mobile
}

// 忘记密码
export const recover = {
  email : [
    { required: true, message: '请输入邮箱', trigger: 'blur, change' },
    email[0]
  ],
  loginName
}

export default {
  ...roles,
  ...users,
  ...password
}



// WEBPACK FOOTER //
// ./src/utils/rule-mixin.js